import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	assetLocationHistoryList: {
		requesting: false,
		items: [],
		pagination: {
			current_page: 1,
			per_page: 10,
			total: 0,
		},
		error: null,
		success: false,
		filters: {},
	},
	assetLocationHistoryDetails: {
		requesting: false,
		data: null,
		error: null,
		success: false,
	},
};

export const assetLocationHistorySlice = createSlice({
	name: "assetLocationHistory",
	initialState,
	reducers: {
		getAssetLocationHistoryList: (state, action) => {
			state.assetLocationHistoryList.requesting = true;
			state.assetLocationHistoryList.error = null;
			state.assetLocationHistoryList.items = [];
			state.assetLocationHistoryList.success = false;
			state.assetLocationHistoryList.filters = action.payload;
		},

		getAssetLocationHistoryListSuccess: (state, action) => {
			const { data, current_page, per_page, total } = action.payload;

			state.assetLocationHistoryList.requesting = false;
			state.assetLocationHistoryList.items = data;
			state.assetLocationHistoryList.success = true;
			state.assetLocationHistoryList.pagination.current_page = current_page;
			state.assetLocationHistoryList.pagination.per_page = per_page;
			state.assetLocationHistoryList.pagination.total = total;
		},

		getAssetLocationHistoryListFail: (state, action) => {
			state.assetLocationHistoryList.requesting = false;
			state.assetLocationHistoryList.error = action.payload;
		},

		getAssetLocationHistoryDetails: (state) => {
			state.assetLocationHistoryDetails.requesting = true;
			state.assetLocationHistoryDetails.error = null;
			state.assetLocationHistoryDetails.data = null;
			state.assetLocationHistoryDetails.success = false;
		},

		getAssetLocationHistoryDetailsSuccess: (state, action) => {
			state.assetLocationHistoryDetails.requesting = false;
			state.assetLocationHistoryDetails.data = action.payload;
			state.assetLocationHistoryDetails.success = true;
		},

		getAssetLocationHistoryDetailsFail: (state, action) => {
			state.assetLocationHistoryDetails.requesting = false;
			state.assetLocationHistoryDetails.error = action.payload;
		},

		doAssetLocationHistoryReset: (state) => {
			state.assetLocationHistoryDetails.data = null;
		},
	},
});

export const {
	getAssetLocationHistoryList, getAssetLocationHistoryListSuccess,
	getAssetLocationHistoryListFail,getAssetLocationHistoryDetails,
	getAssetLocationHistoryDetailsSuccess,getAssetLocationHistoryDetailsFail,
	doAssetLocationHistoryReset,
} = assetLocationHistorySlice.actions;

export default assetLocationHistorySlice.reducer;